import { useQuery } from "@tanstack/react-query";

import { api } from "@/services/api";
import type { MySupportRequest } from "@/types";

/** Query key for the authenticated user's own support requests. */
export const mySupportRequestsKey = ["support", "mine"] as const;

/** The current user's submitted support requests, with any admin Reply. */
export function useMySupportRequests() {
  return useQuery<MySupportRequest[]>({
    queryKey: mySupportRequestsKey,
    queryFn: () => api.listMySupportRequests(),
  });
}
